import React, { useMemo } from "react";
import Flatpickr from "react-flatpickr";
import { Turkish } from "flatpickr/dist/l10n/tr.js";
import "flatpickr/dist/flatpickr.css";

/**
 * Türkçe tarih kutusu (gg/aa/yyyy).
 *
 * Yerine geçtiği `<input type="date">` biçimini siteden değil tarayıcının dil
 * ayarından alır; İngilizce tarayıcıda alan aa/gg/yyyy görünüyordu. Flatpickr
 * biçimi sabitler. Dışarıya karşı sözleşme değişmez: değer her zaman ISO
 * (yyyy-MM-dd) alınır ve ISO verilir, API istekleri aynı kalır.
 *
 * @param {string} value       ISO tarih (yyyy-MM-dd) ya da boş dize
 * @param {Function} onChange  Seçilen ISO tarihi alır; temizlenince "" gelir
 * @param {string} [minDate]   Alt sınır, ISO
 * @param {string} [maxDate]   Üst sınır, ISO
 * @param {boolean} [disabled]
 * @param {string} [className] form-control üzerine eklenir
 */
const pad = (n) => String(n).padStart(2, "0");

export const toIsoDate = (date) =>
    date ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` : "";

// Yerel saat diliminde kurar: new Date("2026-09-20") UTC gece yarısıdır ve
// negatif ofsetli makinede bir gün geri kayar.
const fromIsoDate = (value) => {
    if (!value) return "";
    const [year, month, day] = value.split("-").map(Number);
    return year && month && day ? new Date(year, month - 1, day) : "";
};

const DateInput = ({
    value,
    onChange,
    minDate,
    maxDate,
    disabled = false,
    className = "",
    placeholder = "gg/aa/yyyy",
    ...rest
}) => {
    // react-flatpickr prop kimliğini karşılaştırır: her render'da yeni Date üretmek
    // setDate/set(minDate) çağırır ve allowInput ile yazarken metni sıfırlar.
    const dateValue = useMemo(() => fromIsoDate(value), [value]);
    const options = useMemo(() => ({
        locale: Turkish,
        dateFormat: "d/m/Y",
        allowInput: true,
        minDate: fromIsoDate(minDate) || undefined,
        maxDate: fromIsoDate(maxDate) || undefined,
    }), [minDate, maxDate]);

    return (
        <Flatpickr
            className={`form-control ${className}`.trim()}
            value={dateValue}
            placeholder={placeholder}
            disabled={disabled}
            options={options}
            onChange={(dates) => onChange(toIsoDate(dates[0]))}
            {...rest}
        />
    );
};

export default DateInput;
